module.exports = __webpack_public_path__ + "static/fonts/Alibaba-PuHuiTi-R.c8b8567.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Alibaba-PuHuiTi-R.woff2
// module id = 8Mp2
// module chunks = 52